<template>
  <div>
    <div class="pool_bd">
      <div slot="header">
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-button
              type="primary"
              plain
              style="margin-bottom: 10px"
              @click="backCheckAll()"
              >批量审批</el-button
            >
          </el-col>
        </el-row>
      </div>
      <el-table
        stripe
        ref="tableData"
        v-loading="loadingData"
        :data="tableData"
        :max-height="tableHeight"
        border
        style="width: 100%"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="project_name" label="项目名称">
        </el-table-column>
        <el-table-column prop="total_keep_amount" label="流水">
        </el-table-column>
        <el-table-column prop="divide" label="当前分成比例"> </el-table-column>
        <el-table-column prop="return_amount" label="返还金额">
        </el-table-column>
        <el-table-column label="操作" width="340px">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="backCheck(scope.row.id)"
              >审批</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecords"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
export default {
  name: "backExamine",
  data() {
    return {
      loadingData: false,
      tableData: [],
      tableHeight: 0,
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      searchValue: {
        keyword: "",
      },

      historyValue: {},
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getBackList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["tableData"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getBackList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getBackList(false);
    },

    // 展示返还审核列表数据
    getBackList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/prepaid_pool/upgradeCheckList",
        method: "GET",
        params: {
          page: this.currentPage,
          limit: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },

    // 单行审批
    backCheck(id) {
      this.$confirm("是否审批通过返还金额?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.backCheckSubmit(id);
        })
        .catch(() => {});
    },
    // 审批提交
    backCheckSubmit(id) {
      fetch({
        url: "/admin/prepaid_pool/upgradeCheckAction",
        method: "POST",
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message.success(res.data.data);
          this.getBackList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 批量审批处理
    backCheckAll() {
      let select_ids = [];
      this.$refs.tableData.selection.forEach(function (e, i) {
        select_ids.push(e.id);
      });
      if (select_ids.length == 0) {
        this.$message({
          message: "请选择要审批的数据",
          type: "error",
        });
        return false;
      } else {
        this.backCheckAllSubmit(select_ids);
      }
    },
    //批量审批提交
    backCheckAllSubmit(val) {
      fetch({
        url: "/admin/prepaid_pool/upgradeCheckAction",
        method: "POST",
        data: {
          id: val,
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message.success(res.data.data)
          this.getBackList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>
<style lang="less">
.pool_hd {
  padding: 40px 0;
  border: 1px solid #e9e9e9;
  box-shadow: 0 0 5px #e9e9e9;
  border-radius: 12px;
  ul {
    display: flex;
  }
  li {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: rgba(0, 0, 0, 0.6);
  }
  span {
    color: rgba(0, 0, 0, 0.3);
    font-size: 14px;
  }
  em {
    font-style: normal;
    font-size: 42px;
    font-weight: 600;
  }
}
.pool_bd {
  border: 1px solid #e9e9e9;
  box-shadow: 0 0 5px #e9e9e9;
  border-radius: 12px;
  margin-top: 30px;
  padding: 40px;
}
.pool_bd_title {
  display: flex;

  justify-content: space-between;
  .el-input-group {
    width: 320px;
    margin-left: 30px;
  }
}
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.pool_tab {
  border: 1px solid rgba(0, 0, 0, 0.1);
  // border-radius: 8px;
  height: 40px;
  line-height: 40px;
  display: flex;
  color: rgba(0, 0, 0, 0.5);
  div {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    &:last-child {
      border-right: none;
    }
  }
}
.addGear {
  text-align: center;
  span {
    cursor: pointer;
  }
  i {
    color: #409eff;
    margin-right: 3px;
  }
}
.form-part {
  position: relative;
  .el-select {
    width: 100%;
  }
}
.msg-style {
  color: #eb3941;
  font-size: 12px;
  position: absolute;
  left: 93px;
  top: 42px;
}
.pool_tab_box > div.active {
  background: #409eff;
  color: #ffffff;
}
.pool_tab_box {
  span {
    display: inline-block;
    padding: 0 20px;
  }
}
</style>